var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('order-file-tab-nav'),_c('div',{directives:[{name:"scrollbar",rawName:"v-scrollbar"}],staticClass:"tab-content"},[_c('order-file-tab-menu'),_c('div',{staticClass:"file_content"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }